import { Injectable, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Observable, of } from 'rxjs';
import { Project } from '../models/project.model';

@Injectable({
    providedIn: 'root',
})
export class HttpService {
    private translateService = inject(TranslateService);

    getProjects(): Observable<Project[]> {
        return of([
            {
                id: 0,
                name: this.translateService.instant('PROJECTS.P1.name'),
                description: this.translateService.instant('PROJECTS.P1.description'),
                html: this.translateService.instant('PROJECTS.P1.html'),
                img: `/assets/images/projects/project-5-logos.png`,
                imgBottom: '/assets/images/projects/project-5-logo-bottom.jpg',
                products: [],
            },
            {
                id: 1,
                name: this.translateService.instant('PROJECTS.P2.name'),
                description: this.translateService.instant('PROJECTS.P2.description'),
                html: this.translateService.instant('PROJECTS.P2.html'),
                img: `/assets/images/projects/project-1-logos.jpg`,
                imgBottom: '',
                products: [],
            },
            {
                id: 3,
                name: this.translateService.instant('PROJECTS.P3.name'),
                description: this.translateService.instant('PROJECTS.P3.description'),
                html: this.translateService.instant('PROJECTS.P3.html'),
                img: `/assets/images/projects/project-2-logos.png`,
                imgBottom: '',
                products: [],
            },
        ]);
    }
}
